import { useSite } from "../context/SiteContext";

const S = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-heading text-xl font-bold text-white">{title}</h2>
    <div className="mt-4 space-y-3 text-sm text-slate-400 leading-relaxed">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  const { settings } = useSite();
  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="privacy-policy-page">
      <div className="container-x max-w-3xl">
        <p className="section-label">LEGAL</p>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-black tracking-tight text-white">PRIVACY POLICY</h1>
        <p className="mt-4 text-xs text-slate-500">Built2Last.live · Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <S title="1. Information We Collect">
          <p>We may collect: name, email, phone number, company and business information, project requirements, uploaded files and documents, payment-related information, device information, IP address, browser information, cookies, analytics information and communication records.</p>
        </S>
        <S title="2. How We Use Information">
          <p>We use collected information to: respond to enquiries, prepare estimates, deliver software services, process payments, issue invoices, provide customer support, manage projects, prevent fraud, maintain security, meet legal and compliance obligations, perform analytics and improve our services.</p>
        </S>
        <S title="3. Payment Information">
          <p>Payments may be processed through Razorpay. Payment card details and sensitive payment credentials are processed by the relevant payment provider and are <strong className="text-slate-200">not stored by Built2Last.live</strong> unless explicitly required and lawfully processed. Customers using Razorpay services are also subject to Razorpay's applicable terms, policies and payment-processing rules.</p>
        </S>
        <S title="4. Data Sharing">
          <p>Information may be shared with service providers where necessary, including payment processors, cloud hosting providers, email providers, SMS providers, WhatsApp/communication providers, analytics providers, technology providers, professional advisors, and legal or regulatory authorities where required. Only information necessary for the relevant purpose is shared.</p>
        </S>
        <S title="5. International Customers">
          <p>Customers may access Built2Last.live from outside India. Where applicable, personal information may be processed in India or other countries where service providers operate. Where applicable, we take reasonable steps to comply with data protection laws applicable to our processing activities and customers.</p>
        </S>
        <S title="6. Cookies">
          <p>We use essential cookies, authentication cookies, preference cookies, analytics cookies and security cookies. Your currency preference is stored locally on your device. See our Cookie Policy for details and controls.</p>
        </S>
        <S title="7. Data Retention">
          <p>Information may be retained for providing services, accounting, tax, legal compliance, dispute resolution, security and business records. Data is deleted or anonymized when no longer required, subject to legal obligations.</p>
        </S>
        <S title="8. Data Security">
          <p>We implement reasonable safeguards designed to protect information against unauthorized access, alteration, disclosure or destruction. No method of transmission or storage is completely secure.</p>
        </S>
        <S title="9. Your Rights">
          <p>You may contact us regarding access, correction or deletion of your personal data, or any privacy questions or concerns, at <a className="text-flame underline" href={`mailto:${settings.privacy_email}`} data-testid="privacy-email-link">{settings.privacy_email}</a>.</p>
        </S>
        <S title="10. Contact">
          <p>Built2Last.live · {settings.contact_email} · {settings.address}</p>
        </S>
      </div>
    </div>
  );
}
